import { ChangeDetectionStrategy, Component, Injector, OnInit } from '@angular/core';
import { InlineConfig } from '../types/inline-configs';
import { InputBase } from './input-base';

@Component({
	selector: 'inline-editor-range',
	styleUrls: ['./input.component.css'],
	template: `<input
		#inputRef
		type="range"
		class="form-control"
		(keyup.enter)="onEnter($event)"
		(keyup.escape)="onEscape($event)"
		(focus)="onFocus($event)"
		(blur)="onBlur($event)"
		(click)="onClick($event)"
		(keypress)="onKeyPress($event)"
		[(ngModel)]="value"
		[required]="config.required"
		[disabled]="state.isDisabled()"
		[name]="config.name"
		[placeholder]="config.placeholder"
		[min]="config.min"
		[max]="config.max"
	/>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputRangeComponent extends InputBase implements OnInit {
	constructor(injector: Injector) {
		super(injector);
		this.isNumeric = true;
	}

	public config: InlineConfig;
}
